var map = {
	"./AccountSecurity": [
		"e3e1",
		"chunk-2d225650"
	],
	"./AccountSecurity.vue": [
		"e3e1",
		"chunk-2d225650"
	],
	"./Complaints": [
		"19ff",
		"chunk-2d0ac9de"
	],
	"./Complaints.vue": [
		"19ff",
		"chunk-2d0ac9de"
	],
	"./Deactivation": [
		"a4c7",
		"chunk-2d20885d"
	],
	"./Deactivation.vue": [
		"a4c7",
		"chunk-2d20885d"
	],
	"./Disputes": [
		"2d1e",
		"chunk-2d0bd93c"
	],
	"./Disputes.vue": [
		"2d1e",
		"chunk-2d0bd93c"
	],
	"./Faq": [
		"a049",
		"chunk-2d2073aa"
	],
	"./Faq.vue": [
		"a049",
		"chunk-2d2073aa"
	],
	"./FeesAndCharges": [
		"f4fd",
		"chunk-2d22cec2"
	],
	"./FeesAndCharges.vue": [
		"f4fd",
		"chunk-2d22cec2"
	],
	"./GettingStarted": [
		"c998",
		"chunk-30e101e8"
	],
	"./GettingStarted.vue": [
		"c998",
		"chunk-30e101e8"
	],
	"./Maintenance": [
		"af11",
		"chunk-2d213dfb"
	],
	"./Maintenance.vue": [
		"af11",
		"chunk-2d213dfb"
	],
	"./Membership": [
		"281a",
		"chunk-2d0b340c"
	],
	"./Membership.vue": [
		"281a",
		"chunk-2d0b340c"
	],
	"./PartnerMerchant": [
		"a109",
		"chunk-2d2076ef"
	],
	"./PartnerMerchant.vue": [
		"a109",
		"chunk-2d2076ef"
	],
	"./Services": [
		"f6f0",
		"chunk-2d22d610"
	],
	"./Services.vue": [
		"f6f0",
		"chunk-2d22d610"
	],
	"./Verification": [
		"efa3",
		"chunk-2d231549"
	],
	"./Verification.vue": [
		"efa3",
		"chunk-2d231549"
	],
	"./services/BankTransfers": [
		"a63c",
		"chunk-2d208a3b"
	],
	"./services/BankTransfers.vue": [
		"a63c",
		"chunk-2d208a3b"
	],
	"./services/BuyLoad": [
		"458b",
		"chunk-2d0c1261"
	],
	"./services/BuyLoad.vue": [
		"458b",
		"chunk-2d0c1261"
	],
	"./services/CashIn": [
		"0ce5",
		"chunk-2d0af2d9"
	],
	"./services/CashIn.vue": [
		"0ce5",
		"chunk-2d0af2d9"
	],
	"./services/CashOut": [
		"8ab8",
		"chunk-7c83122e"
	],
	"./services/CashOut.vue": [
		"8ab8",
		"chunk-7c83122e"
	],
	"./services/FundTransfer": [
		"fac3",
		"chunk-2d237721"
	],
	"./services/FundTransfer.vue": [
		"fac3",
		"chunk-2d237721"
	],
	"./services/PayBills": [
		"1a34",
		"chunk-2d0b59a7"
	],
	"./services/PayBills.vue": [
		"1a34",
		"chunk-2d0b59a7"
	],
	"./services/PayQR": [
		"0f86",
		"chunk-2d0af8aa"
	],
	"./services/PayQR.vue": [
		"0f86",
		"chunk-2d0af8aa"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "acc2";
module.exports = webpackAsyncContext;